import * as Constants from '../constants';
import { default as Endpoint } from '../../api/Endpoint';

export function requestContentBuilderSearch() {
  return {
    type: Constants.REQUEST_CONTENT_BUILDER_SEARCH
  };
}

export function receiveContentBuilderSearch(json, error) {
  return {
    type: Constants.RECEIVE_CONTENT_BUILDER_SEARCH,
    data: json,
    error
  };
}

export function requestContentBuilderPreview(id) {
  return () => ({
    type: Constants.REQUEST_CONTENT_BUILDER_PREVIEW,
    id
  });
}

export function receiveContentBuilderPreview(id) {
  return (json, error) => ({
    type: Constants.RECEIVE_CONTENT_BUILDER_PREVIEW,
    id,
    data: json,
    error
  });
}

export function clearContentBuilderSearch() {
  return {
    type: Constants.CLEAR_CONTENT_BUILDER_SEARCH
  };
}

export function fetchContentBuilderPreview(id, options = {}) {
  const path = `ecs/api/content_builder/assets/${encodeURIComponent(
    id
  )}/preview`;
  return new Endpoint(
    path,
    requestContentBuilderPreview(id),
    receiveContentBuilderPreview(id)
  )
    .withOptions(options)
    .call();
}

export function searchContentBuilder(search = null, options = {}) {
  const searchQuery = search ? encodeURIComponent(search) : '';
  const path = `ecs/api/content_builder/assets?search=${searchQuery}`;
  return new Endpoint(
    path,
    requestContentBuilderSearch,
    receiveContentBuilderSearch
  )
    .withOptions(options)
    .call();
}
